import { api } from '@/shared/api/client';
import type { CurrentUser } from '@/shared/stores/session';

export interface LoginResponse {
  expiresAt: string;
}

export function signIn(email: string, password: string): Promise<LoginResponse> {
  return api.post<LoginResponse>('/auth/login', { email, password });
}

export function signOut(): Promise<void> {
  return api.post<void>('/auth/logout');
}

/**
 * The session cookie is HttpOnly, so the page cannot inspect it. Who is signed in is
 * always resolved by asking the server, which also means a revoked session is discovered
 * on the next load rather than trusted from local state.
 */
export function fetchCurrentUser(): Promise<CurrentUser> {
  return api.get<CurrentUser>('/auth/me', { silent: true });
}

export interface DemoAccount {
  readonly email: string;
  readonly password: string;
  readonly roleCode: string;
  readonly roleName: string;
  readonly fullName: string;
  readonly summary: string;
}

/**
 * Empty unless the deployment publishes demo credentials, which production never does.
 * The decision is the server's: the browser is served the same compiled bundle in every
 * environment, so a build-time flag could only be wrong in one of them.
 */
export function fetchDemoAccounts(): Promise<DemoAccount[]> {
  return api.get<DemoAccount[]>('/auth/demo-accounts');
}
